import axios from "../components/shared/axios";

const baseURL = `${process.env.REACT_APP_BACKEND_URL}`;

export const getSignUps = async (pageNo, pageSize, param) => {
  try {
    let params = {};
    if (param) params = { pageNo, pageSize, ...param };
    else params = { pageNo, pageSize };
    return await axios.get(`${baseURL}/admin-signup-records`, { params });
  } catch (error) {
    return { error: error.message };
  }
};
